<div class="accordion-container">
  <div class="accordion">
    <div class="accordion-header row">
      <div class="col-10">
        <span>{{ titulo }}</span>
      </div>
      @if(possuiConteudo) {
      <div tabindex="0" class="col-2" (click)="toggle()" (keyup.enter)="toggle()">
        @if(isOpen){
        <i class="fas fa-2x fa-chevron-up" style="color: var(--tom-2-jornal);"></i>
        } @else {
        <i class="fas fa-2x fa-chevron-down" style="color: var(--tom-2-jornal);"></i>
        }
      </div>
      }
    </div>
  </div>
  @if(isOpen) {
  <div class="accordion-content">
    <ng-content></ng-content>
  </div>
  }
</div>
